import React, {useState} from "react";
import HomeHomeContent from "../components/home/HomeHomeContent";
import HomeShortsContent from "../components/home/HomeShortsContent";
import HomeAnalyticsContent from "../components/home/HomeAnalyticsContent";
import HomeUserProfileContent from "../components/home/HomeUserProfileContent";
import HomeSettingsContent from "../components/home/HomeSettingsContent";
import HomeHelpContent from "../components/home/HomeHelpContent";
import SideBar from "../components/SideBar";
import {AnimatePresence, motion} from "framer-motion";

const Dashboard = () => {
    const [activeMenuItem, setActiveMenuItem] = useState('Home');
    const contentComponents = {
        Home: HomeHomeContent,
        'My Shorts': HomeShortsContent,
        'Create New Short': HomeShortsContent,
        'Short Queue': HomeShortsContent,
        'Publish Shorts': HomeShortsContent,
        Analytics: HomeAnalyticsContent,
        'User Profile': HomeUserProfileContent,
        Settings: HomeSettingsContent,
        Help: HomeHelpContent
    };
    const Content = contentComponents[activeMenuItem] || HomeHomeContent;
    return (
        <div className="flex h-screen bg-gray-50">
            <SideBar activeMenuItem={activeMenuItem} setActiveMenuItem={setActiveMenuItem} />
            <div className="flex-1 overflow-auto px-6 py-8 md:p-8">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeMenuItem}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{
                            duration: 0.2,
                            ease: 'easeOut'
                        }}
                        className="max-w-7xl mx-auto"
                    >
                        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 md:mb-8 text-gray-800 tracking-tight">
                            {activeMenuItem === 'Home'
                                ? 'Welcome back, Creator!'
                                : activeMenuItem
                            }
                        </h2>
                        <div className="min-h-[200px]">
                            <Content />
                        </div>
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};
export default Dashboard
